module.exports = __webpack_public_path__ + "static/media/13.3ee64ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/13.png
// module id = 1510
// module chunks = 0